import styled, { css } from 'styled-components';

const variantes = {
  primario: css`
    background: ${({ theme }) => theme.colors.sage};
    color: #ffffff;
    border: 1px solid transparent;

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.sageDark};
    }
  `,
  secundario: css`
    background: transparent;
    color: ${({ theme }) => theme.colors.sageDeep};
    border: 1px solid ${({ theme }) => theme.colors.sage};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.sageLight};
    }
  `,
  fantasma: css`
    background: transparent;
    color: ${({ theme }) => theme.colors.textMuted};
    border: 1px solid transparent;

    &:hover:not(:disabled) {
      color: ${({ theme }) => theme.colors.text};
      background: ${({ theme }) => theme.colors.sand};
    }
  `,
  peligro: css`
    background: transparent;
    color: ${({ theme }) => theme.colors.danger};
    border: 1px solid ${({ theme }) => theme.colors.danger};

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.colors.dangerLight};
    }
  `,
  peligroSolido: css`
    background: ${({ theme }) => theme.colors.danger};
    color: #ffffff;
    border: 1px solid transparent;

    &:hover:not(:disabled) {
      background: #9d453c;
    }
  `,
};

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space.sm};
  min-height: 44px;
  padding: 0.65rem 1.4rem;
  border-radius: ${({ theme }) => theme.radii.pill};
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: background 200ms ease, color 200ms ease, border-color 200ms ease;
  ${({ $variante }) => variantes[$variante] || variantes.primario}
  ${({ $completo }) => $completo && 'width: 100%;'}
  ${({ $chico }) => $chico && css`
    min-height: 38px;
    padding: 0.4rem 1rem;
    font-size: 0.85rem;
  `}

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export default Button;
